/**
* A modal jqueryUI dialog that prevents the user from interacting with the UI.
* It also displays a custom message.
*/
var BlockUIView = Backbone.View.extend({
  tagName: 'div',

  render: function() {
    var self = this;
    this.el = $(this.el);
    this.el.html(self.options.message);
    this.el.dialog({
      autoOpen: true,
      modal: true,
      resizable: false,
      draggable: false,
      width: 300,
      minHeight: 0,
      dialogClass: 'no-title block-ui',
      zIndex: 3000,
      close: function() {
        self.remove(); // remove the view
      }
    });

    return this;
  }

});
